const showmax = require('../../assets/showmax.png')
const beaucoup = require('../../assets/beaucoup.png')
const chuma = require('../../assets/chuma.png')
const phabias = require('../../assets/phabias.png')
const hotelhub = require('../../assets/Hotelhub.jpg')
const beauty = require('../../assets/Beaucoup.jpg')
const moringa = require('../../assets/Moringaproject.jpg')




 const projects = [
    {
        id:1,pic:chuma,title:'Chuma Gym', desc:'We all need to exercise to keep our bodies healthy. Chuma is a react app that displays one of the best gyms in town.',demo: 'https://andy3643.github.io/chuma-react/',
        githublink:'https://github.com/Andy3643/chuma-react',category:'frontend'
    },
    {
        id:2,pic:beaucoup,title:'Beaucoup E-commerce', desc:'Beaucoup is an E-commerce website specializing in skin care products. The UI is writen in Javasrcipt i.e React',demo: 'https://beaucoup.pages.dev/',
        githublink:'https://github.com/Andy3643/Beaucop-product',category:'frontend'
    },
    {
        id:3, pic:phabias,title:'Phabias Portfolio', desc:'Phabias is a freelance Photographer and Home internet provider in Nairobi. Check out his portfolio built in React.',demo: 'https://andy3643.github.io/phabias-photography/',
        githublink:'https://github.com/Andy3643/phabias-photography',category:'frontend'
    },
    {
        id:4,pic:showmax,title:' ShowMax clone', desc:'This app consumes showMax API. It helps you follow your favourite shows',demo: 'jdfgdghgggh',
        githublink:'dssgsdgfjhjhjsjh',category:'frontend'
    },
    {
        id:5,pic:hotelhub,title:'Hotel Hub', desc:'UI design for hotel booking website. The website allows users to search hotels in their area and book depending on the number of nights they spend.',demo: 'https://www.figma.com/file/d9nZEVERHh9SRvuZSJ5aUF/Hotel-Hub?node-id=0%3A1&t=M3X6JTGVbdh6MID0-0',
        githublink:'https://github.com/Andy3643/hotelhub',category:'ux'
    },
    {
        id:6,pic:beauty,title:'Beaucoup E-commerce', desc:'E-commerce has become a requirement for most businesses. UI was built in Figma.',demo: 'https://andybeaucoup.herokuapp.com/',
        githublink:'https://github.com/Andy3643/Beaucoup',category:'backend'
    },
    {
        id:7,pic:beauty,title:'Beaucoup E-commerce', desc:'E-commerce has become a requirement for most businesses. UI was built in Figma.',demo: 'https://www.figma.com/file/ibj1UwmfIfOJCJToiow7tU/Beacoup?node-id=0%3A1&t=PBDUlc1hYTf9o7He-0',
        githublink:'https://github.com/Andy3643/Beaucoup',category:'ux'
    },
    {
        id:8,pic:moringa,title:'Moringa Project Manager', desc:'Moringa project manager allows students to upload their coding projects for easy management and tracking.',demo: 'https://www.figma.com/file/1jj9XWOr0ZqNK817pEsGSd/Project-Tracker?t=M3X6JTGVbdh6MID0-0',
        githublink:'https://www.figma.com/file/1jj9XWOr0ZqNK817pEsGSd/Project-Tracker?t=M3X6JTGVbdh6MID0-0',category:'ux'
    }

 ]
 export default projects